module.exports = __webpack_public_path__ + "static/award-epick-9af9cf55c7767b5a6382aaf4a5b6fe94.png";